export const OVERLAY_TARGET_EVENT_ID = 'OVERLAY_TARGET_EVENT_ID'

export const DRAG_THRESHOLD = 200 // Minimum pixels to consider as a drag

export const MAX_DRAG_DURATION = 300

export const BOTTOM_SHEET_MAX_DRAG = 0.35
